import type { ReactNode } from 'react';

interface ManagementSectionProps {
  title: string;
  description: string;
  status?: 'active' | 'coming-soon';
  children: ReactNode;
}

const StatusBadge = ({ status }: { status: 'active' | 'coming-soon' }) => {
  if (status === 'coming-soon') {
    return (
      <div className="inline-flex items-center px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-amber-50 text-amber-900 border border-amber-200 whitespace-nowrap">
        Coming Soon
      </div>
    );
  }

  return (
    <div className="inline-flex items-center px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-primary-50 text-primary-800 border border-primary-200 whitespace-nowrap">
      Active
    </div>
  );
};

export const ManagementSection = ({ 
  title, 
  description, 
  status = 'coming-soon', 
  children 
}: ManagementSectionProps) => {
  return (
    <section className="bg-gray-50 border border-gray-200 rounded-lg p-4 md:p-6 hover:shadow-sm transition-shadow">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 md:gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
            {title}
          </h2>
          <p className="text-sm md:text-base text-gray-600 line-clamp-2 md:line-clamp-none">
            {description}
          </p>
        </div>
        <div className="flex-shrink-0">
          <StatusBadge status={status} />
        </div>
      </div>
      
      {children}
    </section>
  );
};